
export interface Entity {
	id: number;
}
export interface NamedEntity extends Entity {
	name: string;
}
export enum LanguageType {
	en,
	ua,
	ru
}
export enum UserTheme {
	Light,
	Dark,
}

export interface PageIn {
	userInput: string;
	page: number;
	pageSize: number;
}
export interface PageOut<T> {
	total: number;
	page: number;
	items: T[];
}

